/* tslint:disable */
/* eslint-disable */
/**
 * Lightly API
 * Lightly.ai enables you to do self-supervised learning in an easy and intuitive way. The lightly.ai OpenAPI spec defines how one can interact with our REST API to unleash the full potential of lightly.ai
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: support@lightly.ai
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// SRC: https://github.com/OpenAPITools/openapi-generator/blob/master/modules/openapi-generator/src/main/resources/typescript-fetch/modelEnumInterfaces.mustache
// synched 02.02.2023
import * as yup from 'yup';
import * as fastJSON from 'fast-json-stringify';
import { StringSchema } from 'fast-json-stringify';
/**
 *
 * @export
 * @enum {string}
 */
export enum SelectionStrategyTypeV3 {
    DIVERSITY = 'DIVERSITY',
    WEIGHTS = 'WEIGHTS',
    THRESHOLD = 'THRESHOLD',
    BALANCE = 'BALANCE',
    SIMILARITY = 'SIMILARITY',
    TYPICALITY = 'TYPICALITY'
}
/* LIGHTLY CUSTOM START -> modelEnumInterfaces */
export const SelectionStrategyTypeV3ValidatorShape = [
    'DIVERSITY',
    'WEIGHTS',
    'THRESHOLD',
    'BALANCE',
    'SIMILARITY',
    'TYPICALITY'
];
export const SelectionStrategyTypeV3Validator = yup.mixed().oneOf(SelectionStrategyTypeV3ValidatorShape);
export const SelectionStrategyTypeV3StringifyShapeProperties = {};
export const SelectionStrategyTypeV3StringifyShape: StringSchema = {
    title: 'SelectionStrategyTypeV3 Stringifier',
    type: 'string'
};
export const SelectionStrategyTypeV3Stringify = (typeof process === 'object' && String(process) === '[object process]') ?
    fastJSON.build(SelectionStrategyTypeV3StringifyShape)
    :
        () => { throw new Error('fast-json-stringify only works in nodejs'); };
/* LIGHTLY CUSTOM END */
export function SelectionStrategyTypeV3FromJSON(json: any): SelectionStrategyTypeV3 {
    return SelectionStrategyTypeV3FromJSONTyped(json, false);
}
export function SelectionStrategyTypeV3FromJSONTyped(json: any, ignoreDiscriminator: boolean): SelectionStrategyTypeV3 {
    return json as SelectionStrategyTypeV3;
}
export function SelectionStrategyTypeV3ToJSON(value?: SelectionStrategyTypeV3 | null): any {
    return value as any;
}
